// extracted by mini-css-extract-plugin
export default {"wrapper":"u8M13aUO--styles_wrapper__HglXA","row":"u8M13aUO--styles_row__g-JVE","shimmer":"u8M13aUO--styles_shimmer__TASyy"};